"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  SocialLogin: true,
  SOCIAL_MAP: true,
  FacebookLoginButton: true,
  FacebookLoginComponent: true
};
Object.defineProperty(exports, "SocialLogin", {
  enumerable: true,
  get: function get() {
    return _SocialLogin.default;
  }
});
Object.defineProperty(exports, "SOCIAL_MAP", {
  enumerable: true,
  get: function get() {
    return _SocialLogin.SOCIAL_MAP;
  }
});
Object.defineProperty(exports, "FacebookLoginButton", {
  enumerable: true,
  get: function get() {
    return _FacebookLoginButton.default;
  }
});
Object.defineProperty(exports, "FacebookLoginComponent", {
  enumerable: true,
  get: function get() {
    return _FacebookLoginComponent.default;
  }
});

var _SocialLogin = _interopRequireWildcard(require("./SocialLogin"));

var _FacebookLoginButton = _interopRequireDefault(require("./FacebookLoginButton"));

var _FacebookLoginComponent = _interopRequireDefault(require("./FacebookLoginComponent"));

var _constants = require("./constants");

Object.keys(_constants).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _constants[key];
    }
  });
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
//# sourceMappingURL=index.js.map